export default __webpack_public_path__ + "static/media/current-active.628f1e1e.svg";